<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm" inline>
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" type="radio" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
					<c-form-item type="input" label="规格" name="product_sku_spec"></c-form-item>
					<c-form-item type="select" label="商品类目" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
					<c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<c-table-column
					label="运营模式"
					name="operation_mode"
					width="80"
					v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" 
				>
					<template v-slot="{data}">
						{{orderModeName[data.operation_mode]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="商家角色"
					name="stationed_auth_name"
					width="110"
					v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'" 
				>
				</c-table-column>
				
				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="150"
					v-if="systemConfig.pt_mode == 2" 
				></c-table-column>

<!--				<c-table-column-->
<!--					label="商品ID"-->
<!--					width="80"-->
<!--					name="product_id"-->
<!--				></c-table-column>-->
				
				<c-table-column
					label="商品名称"
					name="product_name"
					width="350"
				>
					<template v-slot="{data}">
						<div class="flex-center-cross">
							<p v-if="data.product_itemnumber">{{data.product_itemnumber}} - </p>
							<p>{{data.product_name}}</p>
						</div>
					</template>
				</c-table-column>
				
				<c-table-column
					label="规格"
					name="product_sku_spec"
					width="120"
				>
				</c-table-column>

				<c-table-column
					label="所属类目"
					name="product_type_full_name"
					width="220"
				>
				</c-table-column>

				<c-table-column
					label="销量"
					name="sales_quantity"
					width="100"
                    sortable
				>
				</c-table-column>
				
				<c-table-column
					label="销售额"
					name="sales_amount"
					width="100"
                    sortable
				>
					<template v-slot="{data}">
						￥{{data.sales_amount}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="支付人数"
					name="pay_user_quantity"
					width="100"
                    sortable
				>
				</c-table-column>

				<c-table-column
					label="退款数量"
					name="cancel_quantity"
					width="100"
                    sortable
				>
				</c-table-column>

				<c-table-column
					label="退款总额"
					name="cancel_amount"
					width="110"
                    sortable
				>
					<template v-slot="{data}">
						￥{{data.cancel_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="退货数量"
					name="return_quantity"
					width="100"
                    sortable
				>
				</c-table-column>

				<c-table-column
					label="退货总额"
					name="return_amount"
					width="110"
                    sortable
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	export default {
		name: 'm_statistic_product',
		data() {
			return {
				productType: [],
				orderModeName: {
					1: '平台自营',
					2: '商家自营'
				},
				operationMode: [{
						name: '平台自营',
						value: 1
					},{
						name: '商家运营',
						value: 2
					}
				]
			}
		},
		
		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},
		
		computed: {
			...mapState(['systemConfig'])
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/statistic/product/list',
					data
				});
			},
			exportData(){
				var exportData = this.$refs.searchForm.serialize();
				exportData.job_id = 33;
				exportData.create_system = 'OMS';
				exportData.sort_by = this.$refs.table.sortBy||'';
				exportData.sort_type = this.$refs.table.sortType||'';
				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>